export default __webpack_public_path__ + "static/media/Snd2.80063ea6.mp3";